// src/wizard/wizardState.ts
import { volunteerAvailabilityDays } from "../constants/volunteerAvailabilityDays";

export type ParentInfoState = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  relationToChild: string;
  pickupType: string;
  passphrase: string;
};

export type VolunteerInfoState = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  ageGroup: string;
  grade: string;
  tshirtSize: string;
  church: string;
  availabilityDays: string[];
  availabilityNotes: string;
  relationToChild: string;
  pickupType: string;
  passphrase: string;
  comments: string;
};

export type ChildState = {
  firstName: string;
  lastName: string;
  age: string;
  grade: string;
  allergies: string;
  specialNeeds: string;
  tshirtSize: string;
  requestedGroup: string;
};

export type EmergencyContactState = {
  firstName: string;
  lastName: string;
  phone: string;
  relation: string;
};

export type WizardFormState = {
  parentInfo: ParentInfoState;
  volunteers: VolunteerInfoState[];
  children: ChildState[];
  emergencyContacts: EmergencyContactState[];
};

export function createDefaultWizardFormState(): WizardFormState {
  return {
    parentInfo: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      relationToChild: "",
      pickupType: "",
      passphrase: "",
    },
    volunteers: [
      {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        street: "",
        city: "",
        state: "",
        zip: "",
        ageGroup: "",
        grade: "",
        tshirtSize: "",
        church: "",
        availabilityDays: volunteerAvailabilityDays.map((day) => day.value),
        availabilityNotes: "",
        relationToChild: "",
        pickupType: "",
        passphrase: "",
        comments: "",
      },
    ],
    children: [
      {
        firstName: "",
        lastName: "",
        age: "",
        grade: "",
        allergies: "",
        specialNeeds: "",
        tshirtSize: "",
        requestedGroup: "",
      },
    ],
    emergencyContacts: [
      { firstName: "", lastName: "", phone: "", relation: "" },
    ],
  };
}
